import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c938bcc3f84800139358f5/netmanager/src/app/abbonamento/page.tsx");
